import { FlowConfig } from '@/components/SimplifiedSignup/Context/types';

import MonthlyOfferScreensConfig from './Screens';

const MonthlyOfferFlow: FlowConfig = {
	activeScreenKey: 'account',
	activeScreenConfig: MonthlyOfferScreensConfig.account,
	name: 'MonthlyOffer',
	pageName: 'monthly_offer',
	screens: {
		account: MonthlyOfferScreensConfig.account,
		payment: MonthlyOfferScreensConfig.payment,
		handoff: MonthlyOfferScreensConfig.handoff,
	},
	plan: 'monthly',
	allowChurned: true,
	hasFreeTrial: false,
	offerCountries: null,
	offerCurrencies: null,
	fauxAuth: true,
};

export default MonthlyOfferFlow;
